var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sleep-record" }, [
    _c("div", { staticClass: "record-header" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "time-tabs" },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.value,
              class: ["tab-btn", { active: _vm.activeTab === tab.value }],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange(tab.value)
                },
              },
            },
            [_vm._v(" " + _vm._s(tab.label) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "record-content" }, [
      _c("div", { staticClass: "left-chart" }, [
        _c("div", { ref: "pieChart", staticClass: "pie-chart" }),
        _c(
          "div",
          { staticClass: "chart-legend" },
          _vm._l(_vm.displayPieData, function (item, index) {
            return _c("div", { key: index, staticClass: "legend-item" }, [
              _c("span", {
                staticClass: "legend-dot",
                style: { background: item.itemStyle.color },
              }),
              _c("span", { staticClass: "legend-text" }, [
                _vm._v(_vm._s(item.name)),
              ]),
              _c("span", { staticClass: "legend-value" }, [
                _vm._v(_vm._s(item.value) + "天"),
              ]),
            ])
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "right-chart" },
        [
          _c("HealthChart", {
            ref: "healthChart",
            staticClass: "sleep-health-chart",
            attrs: {
              title: "",
              "chart-type": "line",
              "view-type": _vm.activeTab,
              "day-data": _vm.dayData,
              "primary-color": _vm.primaryColor,
              "secondary-color": _vm.secondaryColor,
              "bar-color": _vm.barColor,
              "icon-bg-color": _vm.iconBgColor,
              "chart-data": _vm.chartData,
              "x-axis-data": _vm.xAxisData,
              "y-axis-max": 12,
              "area-opacity": 0.25,
              "show-charts": _vm.showChart,
              "chart-height": "220px",
              "show-label": true,
            },
            on: { "tab-change": _vm.onHealthChartTabChange },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-wrapper" }, [
      _c("div", { staticClass: "title-bar" }),
      _c("h3", { staticClass: "title" }, [_vm._v("睡眠记录")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }